const faqs = [
    {
        id: 1,
        heading: 'How to buy your products Online?',
        content: 'To buy our products online, simply browse through our catalog, add items to your cart, and proceed to checkout. You can place your order by filling in your shipping details and completing the payment process securely.',
    },
    {
        id: 2,
        heading: 'When can I place my order?',
        content: 'You can place your order online 24/7. Our system is always active, and we process orders during business hours. Orders placed on holidays or weekends will be processed the next working day.',
    },
    {
        id: 3,
        heading: 'What if an item is out-of-stock?',
        content: 'If an item is out-of-stock, you’ll see a notification on the product page. You can choose to be notified when it’s back in stock or explore similar alternatives available on our site.',
    },
    {
        id: 4,
        heading: 'Do you accept coupons?',
        content: 'Yes, we do accept valid coupons. You can apply a coupon code during the checkout process to avail discounts. Make sure the coupon is within its validity period and meets the conditions.',
    },
    {
        id: 5,
        heading: 'How do I pay for the order?',
        content: 'We accept multiple payment methods including credit/debit cards, digital wallets, and bank transfers. All transactions are processed securely to ensure the safety of your information.',
    },
];

export default faqs;